import { withPageAuthRequired } from '@auth0/nextjs-auth0';
import { Component } from 'react';
import { GTMPageView } from '../utility/gtm';
import Router from 'next/router';
import gtmConfig from '../config/gtm';
import TagManager from 'react-gtm-module';
import { WithSessionProps, withSession } from '../auth/higherOrderComponents';

class InitGTMView extends Component<WithSessionProps> {
  // Your class component logic here
  handleRouteChange = (url, user) => GTMPageView(url, user);

  componentDidMount() {
    const jssStyles = document.querySelector('#jss-server-side');
    const gtmId = gtmConfig.googleTagManager.id();
    TagManager.initialize({
      gtmId,
      auth: gtmConfig.googleTagManager.auth() || undefined,
      preview: gtmConfig.googleTagManager.env() || undefined,
    });
    if (jssStyles) {
      jssStyles.parentElement?.removeChild(jssStyles);
    }
    const { user } = this.props;
    if (user) {
      Router.events.on('routeChangeComplete', (url) => this.handleRouteChange(url, user));
    }
  }
  componentWillUnmount() {
    const { user } = this.props;
    if (user) {
      Router.events.off('routeChangeComplete', (url) => this.handleRouteChange(url, user));
    }
  }

  render() {
    // shows nothing
    return <></>;
  }
}

//   export const getServerSideProps = withPageAuthRequired();

export default withSession(InitGTMView);
